<div class="ask-grid">
  <div class="card pad">
    <label class="lbl" for="df-q">Make Business Scenario deck for:</label>
    <div class="ask-box">
      <textarea id="df-q" [(ngModel)]="df.query" name="query" placeholder="e.g. Find all as-is and to-be documents for a process"></textarea>
    </div>
    <div class="sugg" aria-label="Suggested questions" *ngIf="suggestions.length">
      <button type="button" *ngFor="let s of suggestions" (click)="useSuggestion(s)">{{ s }}</button>
    </div>
    <div class="row-actions">
      <!-- <span class="hint">AI-generated content may be incorrect.</span> -->
      <button type="button" class="btn pri run-btn" [disabled]="!df.query.trim()" (click)="run()"><df-icon name="search"></df-icon>Find documents</button>
    </div>
  </div>

  <div class="card pad scope">
    <h3>Scope the agent will use</h3>
    <p class="hint" style="margin:0 0 6px">Read from your question. Change anything before you run.</p>

    <div class="sec">
      <p class="lbl">Business Scenarios</p>
      <div class="toggles">
        <button type="button" class="tg tg-l2" *ngFor="let x of selectedProcesses"
          aria-pressed="true" [disabled]="df.scope.l2.size === 1"
          [attr.aria-label]="'Remove ' + x.id" [title]="'Remove ' + x.id" (click)="df.toggleScope('l2', x.id)">
          {{ x.id }} <small>{{ x.name }}</small>
          <df-icon name="x"></df-icon>
        </button>
      </div>
      <details class="process-dropdown" *ngIf="availableProcesses.length">
        <summary>Add business scenarios</summary>
        <div class="process-options" role="group" aria-label="Additional business scenarios">
          <label *ngFor="let x of availableProcesses">
            <input type="checkbox" [attr.aria-label]="x.id" (change)="df.toggleScope('l2', x.id)">
            <span>{{ x.id }} <small>{{ x.name }}</small></span>
          </label>
        </div>
      </details>
      <p class="hint" *ngIf="!l2.length">{{ df.referenceError || 'Loading L2 processes…' }}</p>
    </div>

    <div class="sec">
      <p class="lbl">Landscape</p>
      <div class="seg" role="group" aria-label="Landscape">
        <button type="button" *ngFor="let l of landscapes" [attr.aria-pressed]="df.scope.land === l[0]" (click)="setLandscape(l[0])">{{ l[1] }}</button>
      </div>
    </div>

    <div class="sec">
      <p class="lbl">Document types to retrieve</p>
      <div class="toggles">
        <button type="button" class="tg tg-type" *ngFor="let k of types"
          [attr.aria-pressed]="df.scope.types.has(k)" (click)="df.toggleScope('types', k)">
          <i class="sw" [style.background]="docTypes[k].color"></i>{{ docTypes[k].short }}
        </button>
      </div>
      <div class="io">
        <div><b>Inputs (retrieved)</b>Process flow, BPD, CDD, KT, SDR</div>
        <div><b>Outputs (not retrieved)</b>KDD, PBL, proposed to-be flow, change impacts</div>
      </div>
    </div>

    <div class="sec">
      <p class="lbl">Connect folder (Azure Storage)</p>
      <div class="gconn">
        <p class="hint" style="margin:0 0 10px">Reads the Explore documents from the Azure Storage folder set up for this app.</p>
        <div class="gact">
          <button type="button" class="btn sm pri connect-btn" [disabled]="df.azure.busy" (click)="connect()">
            {{ df.azure.busy ? 'Connecting…' : df.azure.connected ? 'Reconnect' : 'Connect folder' }}
          </button>
          <button type="button" class="btn sm ghost disconnect-btn" *ngIf="df.azure.connected" (click)="df.disconnectFolder()">Disconnect</button>
          <span class="hint" *ngIf="df.azure.progress && !df.azure.error">{{ df.azure.progress }}</span>
        </div>
        <p class="hint ok" *ngIf="df.azure.connected">✓ Connected · {{ df.azure.documents.length }} documents recognised · files stay in Azure Storage until you open or publish them</p>
        <p class="hint err" *ngIf="df.azure.error" role="alert">{{ df.azure.error }}</p>
      </div>
    </div>

    <div class="sec">
      <p class="lbl">Sources</p>
      <div class="toggles">
        <button type="button" class="tg tg-src" *ngFor="let k of sourceKeys"
          [attr.aria-pressed]="df.scope.src.has(k)" (click)="df.toggleScope('src', k)">
          {{ sources[k].name }} <small>{{ sources[k].n === null ? 'Count unavailable' : (sources[k].n | number) + ' files' }}</small>
        </button>
        <button type="button" class="tg tg-src" *ngIf="df.azure.connected && sources[folderKey]"
          [attr.aria-pressed]="df.scope.src.has(folderKey)" (click)="df.toggleScope('src', folderKey)">
          {{ sources[folderKey].name }} <small>{{ sources[folderKey].n | number }} files</small>
        </button>
      </div>
      <p class="hint" *ngIf="!sourceKeys.length">No sources returned by the API.</p>
    </div>
  </div>
</div>
